import { PropsWithChildren } from 'react';

import { ErrorBoundary } from './ErrorBoundary';
import { StatusParamHandler } from '../contexts/params/StatusParamHandler';
import { ThemedPage } from '../contexts/theme';

export function WrapperProviders({ children }: PropsWithChildren) {
  return (
    <ErrorBoundary>
      <ThemedPage>{children}</ThemedPage>
      <StatusParamHandler />
    </ErrorBoundary>
  );
}
